// The resolved label for a canonical code, readable synchronously.
//
// Split out from referenceProvider so that consumers which only need to *read*
// a label — the navigation ribbon renders a chip during layout — don't
// transitively depend on the HTTP client. Presentation code has no business
// importing axios, and doing so also broke any test that rendered it.
//
// The provider writes here when a list resolves; everyone else reads.

/** @typedef {{ code: string, label: string, hint?: string, aliases?: string[] }} ReferenceOption */

/** @type {Map<string, ReferenceOption[]>} */
const resolved = new Map();

/** @param {string} key  domain, plus its params when it has any */
export const remember = (key, items) => resolved.set(key, items);

export const forget = (key) => resolved.delete(key);

export const forgetAll = () => resolved.clear();

export const keys = () => [...resolved.keys()];

/**
 * Best-effort and never triggers a request: returns "" when the list has not
 * been fetched yet, so callers fall back to showing the raw value. That is
 * right for a summary chip and wrong for a dropdown, which uses the async path.
 *
 * @param {string} key
 * @param {string} code
 * @returns {string}
 */
export const labelFor = (key, code) =>
  resolved.get(key)?.find((i) => i.code === String(code))?.label || "";
